import { useState } from 'react'
import { supabase } from '../supabase'
import './Login.css' 

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [nombreComercio, setNombreComercio] = useState('')
  const [telefonoDueno, setTelefonoDueno] = useState('') // Solo almacenará el número local

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [message, setMessage] = useState('') 
  const [view, setView] = useState('login') 

  // Estados para controlar la visibilidad de las contraseñas
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    setMessage('')

    try {
      if (view === 'login') {
        const { error } = await supabase.auth.signInWithPassword({ email, password })
        if (error) throw new Error('Email o contraseña incorrectos')
        
      } else if (view === 'register') {
        // Validar que las contraseñas coincidan estrictamente
        if (password !== confirmPassword) {
          throw new Error('Las contraseñas no coinciden. Verificalas e intentalo de nuevo.')
        }

        const instanciaGenerada = nombreComercio.replace(/\s+/g, '').toLowerCase() + '_' + Math.floor(Math.random() * 10000)
        
        // Concatenamos el prefijo estático con el número local ingresado
        const telefonoCompleto = `+549${telefonoDueno}`

        const { error } = await supabase.auth.signUp({ 
          email, 
          password,
          options: {
            data: {
              nombre: nombreComercio,             
              evolution_instance: instanciaGenerada,
              telefono_dueno: telefonoCompleto // Se envía el teléfono ya armado
            }
          }
        })
        if (error) throw error
        
        // Carga la vista de login y muestra el mensaje para verificar el email
        cambiarVista('login', '¡Registro exitoso! Revisá tu bandeja de entrada (y la de spam) para confirmar tu email antes de ingresar.')
        
      } else if (view === 'forgot') {
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
          redirectTo: window.location.origin, 
        })
        if (error) throw error
        setMessage('Te enviamos un enlace para restablecer tu contraseña. Revisa tu email.')
      }
    } catch (err) {
      setError(err.message || 'Ocurrió un error inesperado')
    } finally {
      setLoading(false)
    }
  }

  // Agregamos el parámetro "nuevoMensaje" para poder pasar alertas al cambiar de vista
  const cambiarVista = (nuevaVista, nuevoMensaje = '') => {
    setView(nuevaVista)
    setError('')
    setMessage(nuevoMensaje)
    setPassword('')
    setConfirmPassword('')
    setTelefonoDueno('')
    setShowPassword(false)
    setShowConfirmPassword(false)
  }

  const titulos = {
    login: { titulo: 'iStore Admin', sub: 'Ingresá con tu cuenta para continuar' },
    register: { titulo: 'Crear Cuenta', sub: 'Registrate para administrar tu negocio' },
    forgot: { titulo: 'Recuperar Contraseña', sub: 'Ingresá tu email para restablecerla' }
  }

  return (
    <div className="login-container">
      <div className="login-card">
        
        <div className="login-header">
          <div className="login-icon">📱</div>
          <h1 className="login-title">{titulos[view].titulo}</h1>
          <p className="login-subtitle">{titulos[view].sub}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          
          {view === 'register' && (
            <>
              <div className="form-group">
                <label className="form-label">Nombre de tu Comercio</label>
                <input
                  type="text" 
                  className="form-input"
                  value={nombreComercio} 
                  onChange={e => setNombreComercio(e.target.value)}
                  placeholder="Ej: Celulares Pérez" 
                  required 
                />
              </div>

              <div className="form-group">
                <label className="form-label">Teléfono del Dueño</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{
                    backgroundColor: '#f1f5f9',
                    padding: '10px 14px',
                    borderRadius: '6px',
                    border: '1px solid #cbd5e1',
                    color: '#475569',
                    fontWeight: '600',
                    fontSize: '14px'
                  }}>
                    +54 9
                  </span>
                  <input
                    type="tel" 
                    className="form-input"
                    value={telefonoDueno} 
                    onChange={e => setTelefonoDueno(e.target.value.replace(/\D/g, ''))} // Solo permite números
                    placeholder="1123456789" 
                    required 
                    style={{ flex: 1 }}
                  />
                </div>
              </div>
            </>
          )}

          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email" 
              className="form-input"
              value={email} 
              onChange={e => setEmail(e.target.value)}
              placeholder="tu@email.com" 
              required 
            />
          </div>
          
          {view !== 'forgot' && (
            <>
              <div className="form-group">
                <label className="form-label">Contraseña</label>
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  <input
                    type={showPassword ? "text" : "password"} 
                    className="form-input"
                    value={password} 
                    onChange={e => setPassword(e.target.value)}
                    placeholder={view === 'register' ? "Crea una contraseña segura" : "Tu contraseña"} 
                    required 
                    style={{ paddingRight: '45px', width: '100%' }}
                  />
                  <button 
                    type="button" 
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute', right: '12px', background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', display: 'flex', alignItems: 'center', padding: '0'
                    }}
                  >
                    {showPassword ? (
                      <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                    ) : (
                      <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    )}
                  </button>
                </div>
              </div>

              {view === 'register' && (
                <div className="form-group">
                  <label className="form-label">Confirmar Contraseña</label>
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <input
                      type={showConfirmPassword ? "text" : "password"} 
                      className="form-input"
                      value={confirmPassword} 
                      onChange={e => setConfirmPassword(e.target.value)}
                      placeholder="Repetí la contraseña" 
                      required 
                      style={{ paddingRight: '45px', width: '100%' }}
                    />
                    <button 
                      type="button" 
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      style={{
                        position: 'absolute', right: '12px', background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', display: 'flex', alignItems: 'center', padding: '0'
                      }}
                    >
                      {showConfirmPassword ? (
                        <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                      ) : (
                        <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    )}
                    </button>
                  </div>
                </div>
              )}
            </>
          )}

          {error && <p className="alert-error">{error}</p>}
          {message && <p className="alert-success">{message}</p>}

          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Cargando...' : view === 'login' ? 'Ingresar' : view === 'register' ? 'Crear mi tienda' : 'Enviar enlace'}
          </button>
        </form>

        <div className="login-footer">
          {view === 'login' ? (
            <>
              <button type="button" onClick={() => cambiarVista('forgot')} className="btn-link">
                ¿Olvidaste tu contraseña?
              </button>
              <span className="footer-text">
                ¿No tenés cuenta?{' '}
                <button type="button" onClick={() => cambiarVista('register')} className="btn-link bold">
                  Registrate
                </button>
              </span>
            </>
          ) : (
            <button type="button" onClick={() => cambiarVista('login')} className="btn-link">
              ← Volver al inicio de sesión
            </button>
          )}
        </div>

      </div>
    </div>
  )
}